import { getPrices } from 'fukku/Price/services/productPrice'
import { getMasterData } from 'master-data'
import { ProductCard } from 'product-card/components/ProductCard'
import { ProductCardProvider } from 'product-card/context/ProductCardContext'
import { type ProductCardProps } from 'product-card/types'
import { getServerProductInfo } from 'product/services'

export const ServerProductCard = async ({
	productId,
	lookId,
	colorId,
	imageSortCriteria,
	priority,
	dataTestId,
	isTwoColumnSize,
	className,
	location,
	productListId,
	showDiscount,
	noDraggable,
}: ProductCardProps) => {
	const {
		country: { countryISO, languageISO },
	} = getMasterData()

	const productRequestsParams = {
		productId,
		country: countryISO,
		language: languageISO,
	}

	const [productData, productPrices] = await Promise.all([
		getServerProductInfo(productRequestsParams),
		getPrices(productId, colorId),
	])

	if (!productData) {
		return null
	}

	return (
		<ProductCardProvider
			initialProductId={productId}
			initialDataTestId={dataTestId}
			initialLookId={lookId}
			initialColorId={colorId}
			location={location}
			productListId={productListId}
			noDraggable={noDraggable}
		>
			<ProductCard
				className={className}
				product={productData}
				imageSortCriteria={imageSortCriteria}
				prices={productPrices}
				priority={priority}
				isTwoColumnSize={isTwoColumnSize}
				showDiscount={showDiscount}
			/>
		</ProductCardProvider>
	)
}
